import {
  Badge,
  Button,
  EmptyState,
  Page,
  Table,
  Tag,
} from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';

import { authApi } from 'apis/auth';
import { chatbotsApi } from 'apis/chatbots';
import { appActions } from 'app/app.actions';
import { ChatbotConnectModal } from 'app/views/layout/views/settings/views/chatbots/components/chatbotConnectModal/chatbotConnectModal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { ThirdPartyTableActions } from './components/thirdPartyTableActions/thirdPartyTableActions';
import styles from './settingsChatbotsThirdParty.module.scss';

export const SettingsChatbotsThirdPartyView = (): JSX.Element => {
  const dispatch = useAppDispatch();

  const { chatbots, isLoading, isError } = chatbotsApi.useReadChatbotsQuery(
    undefined,
    {
      selectFromResult: ({ data, ...rest }) => ({
        ...rest,
        chatbots:
          data && Array.isArray(data.data.chatbots)
            ? [...data.data.chatbots].reverse()
            : [],
      }),
    },
  );
  const { tokens } = authApi.useReadApiTokensQuery(undefined, {
    selectFromResult: ({ data, ...rest }) => ({
      ...rest,
      tokens: data?.data.tokens || [],
    }),
  });

  const handleConnectChatbot = async () => {
    ampli.chatbotCreateModalOpened();

    await dispatch(
      appActions.showModal({
        modal: {
          type: 'settings:connectChatbotModal',
          arg: {},
        },
      }),
    );
  };

  return (
    <>
      <Page.Section
        title="Third party chatbots"
        titleMeta={
          chatbots.length > 0 && (
            <Badge size="small" variant="secondary">
              {chatbots.length}
            </Badge>
          )
        }
        controls={
          <Button onClick={handleConnectChatbot}>Connect chatbot</Button>
        }
      >
        <Table stickyHeader loading={isLoading} loadingFailed={isError}>
          <Table.Thead>
            <Table.Tr>
              <Table.Th columnId="name">Name</Table.Th>
              <Table.Th columnId="base">Type</Table.Th>
              <Table.Th />
            </Table.Tr>
          </Table.Thead>

          <Table.Tbody>
            {chatbots.length > 0 ? (
              chatbots.map((chatbot, index) => (
                <Table.Tr key={index}>
                  <Table.Td>{chatbot.name ?? ''}</Table.Td>
                  <Table.Td>
                    <Tag className={styles.type}>{chatbot._type}</Tag>
                  </Table.Td>
                  <Table.Td align="right">
                    <ThirdPartyTableActions chatbot={chatbot} tokens={tokens} />
                  </Table.Td>
                </Table.Tr>
              ))
            ) : (
              <Table.Tr>
                <Table.Td colSpan={4}>
                  <EmptyState
                    icon="chat-bot"
                    title="Third party chatbots"
                    description="Connect your chatbot to Dixa."
                    buttonProps={{
                      children: 'Connect chatbot',
                      onClick: handleConnectChatbot,
                    }}
                  />
                </Table.Td>
              </Table.Tr>
            )}
          </Table.Tbody>
        </Table>
      </Page.Section>
      <ChatbotConnectModal />
    </>
  );
};
